import { App } from './components/app';
import { router } from './routing/router';
import { createPinia } from 'ui.vue3.pinia';
import { BitrixVue, markRaw } from 'ui.vue3';
import { Abtest } from 'b24network.component.abtest';
import { useLoggingInStore } from './pinia/store';
import { RoutePaths } from './routing/route-paths';

export class Init
{
	constructor(appConfig: Object, vueMountPointSelector: string)
	{
		this.#tryInitAnalytics(appConfig.analyticsConfig);
		const app = this.#initVueApp();
		this.#initPiniaStore(appConfig);
		app.mount(vueMountPointSelector);
	}

	#tryInitAnalytics(analyticsConfig: Object): void
	{
		if (analyticsConfig && window.BX.Network.Analytics)
		{
			window.BX.Network.Analytics.create(analyticsConfig);
		}
	}

	#initVueApp(): void
	{
		const pinia = createPinia();
		pinia.use(({ store }) => {
			// eslint-disable-next-line no-param-reassign
			store.router = markRaw(router);
		});

		return BitrixVue.createApp({
			components: {
				LoggingInApp: App,
			},
			template: '<LoggingInApp />',
		})
			.use(router)
			.use(pinia)
		;
	}

	#initPiniaStore(config: Object): void
	{
		const store = useLoggingInStore();

		store.legalLinks = config.legalLinks;
		store.defaultCountry = config.defaultCountry;
		store.captchaSettings = config.captchaSettings;
		store.webLoginCaptchaSettings = config.webLoginCaptchaSettings ?? {
			isEnabled: false,
			captchaType: '',
		};
		store.currentLanguageId = config.currentLanguageId;

		store.login = config.login ?? '';
		store.collabName = config.collabName;
		store.userAuthType = config.userAuthType;
		store.qrCodeLink = config.qrCodeLink ?? null;
		store.qrCodeConfig = config.qrCodeConfig ?? {};
		store.userCheckWord = config.userCheckWord ?? '';
		store.enteredPortal = config.enteredPortal ?? null;
		store.forceSsoSignIn = config.forceSsoSignIn ?? false;
		store.isPhoneEnabled = config.isPhoneEnabled ?? false;
		store.passwordRestoreLogin = config.passwordRestoreLogin ?? '';
		store.isDesktopLogin = config.isDesktopLogin ?? false;
		store.shouldShowPortalHostInTitle = config.shouldShowPortalHostInTitle ?? true;
		store.isSigningInToSsoPortal = config.isSigningInToSsoPortal ?? false;
		store.showVibeAuthPromoBlock = config.showVibeAuthPromoBlock ?? false;
		store.vibecodeContinueTermsHtml = config.vibecodeContinueTermsHtml ?? '';
		store.legalConsentSign = config.legalConsentSign ?? '';
		store.passwordSetUpUserDetails = config.passwordSetUpUserDetails ?? null;
		store.redirectToPortalsListWhenAuthorized = config.redirectToPortalsListWhenAuthorized;
		store.redirectUrlWhenAuthorized = config.redirectUrlWhenAuthorized;
		store.notYetAcceptedInvites = config.notYetAcceptedInvites ?? [];

		const abtest = Abtest.getInstance();
		abtest.setSessionId(config.analyticsConfig?.context?.sessionId ?? '');
		abtest.setExperiments([]);

		store.initAccountsHistory(config.loginHistory ?? []);
		store.initSocialServices(config.socialServices ?? []);
		store.initLoggedInUserAccount(config.signedInUserData ?? null);
		store.updateUserNoticeFromInternalCode(config.internalErrorCode ?? null);
	}

	goToPasswordNotices(): void
	{
		router.replace(RoutePaths.SIGN_IN_NOTICES);
	}
}
